module.exports = __webpack_public_path__ + "df79f747b5a7be4d8c6af738640af6c8.png";